import React from "react";
import "./style.css";
import alarm from "../../assets/img/alarm.png";

const NotificationSidebar = ({ list }: any) => {
  return (
    <div className={"active-notificationSideBar"}>
      <div className="notification-card">
        <div
          style={{ fontFamily: "Open Sans, sans-serif" }}
          className="d-flex justify-content-between mb-3 "
        >
          <div>12 Oct. 2020</div>
          <div>12:30 pm</div>
        </div>
        <div className="d-flex gap-2">
          <div>
            <div
              style={{
                backgroundColor: "#f1f1f1",
                borderRadius: "50%",
              }}
              className="p-2 "
            >
              <img src={alarm} alt="alarm" width={20} />
            </div>
          </div>
          <div className="flex-1 p-1">
            <h6 className="font-weight-bold">
              Congratulations, You have successfully complete profile process!
            </h6>
            <div>
              Reference site about Lorem and Ipsum, giving is information on its
              content type setting and dummy contrast look wise feel information
              origins.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSidebar;
